import axios from 'axios';
import mergeData from './merge';

export const fetchData = async (startDate, endDate) => {
  try {
    const responseDb = await axios.get(process.env.REACT_APP_DB_URL, {
      params: {
        startDate: startDate,
        endDate: endDate,
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    const responseLa = await axios.get(process.env.REACT_APP_LIBANSWERS_URL, {
      params: {
        startDate: startDate,
        endDate: endDate,
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return mergeData(responseDb.data, responseLa.data);
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
